module.exports = __webpack_public_path__ + "static/img/jigou-shenzhen-bottom.fffa3c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-shenzhen-bottom.png
// module id = jaIo
// module chunks = 2